<template>

  <div class="login">

    <mt-header  style="background-color:#26a2ff;color: white"  fixed title="后勤服务监督平台" >
      <router-link to="/" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm" >

      <div  style="align-items:center;">
        <img style="width: 130px; height: 130px;margin-bottom: 20px;margin-top: 20px" src="../assets/logo.png"/>
      </div>


      <el-form-item label="账号" prop="username">
        <el-input v-model="ruleForm.username" autocomplete="on" ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="on"></el-input>
      </el-form-item>

     <!-- <el-form-item prop="verifyCode">
        <el-input type="text"  v-model="ruleForm.verifyCode" placeholder="输入验证码">
          <template slot="append">
            <div class="login-code"  @click="refreshCode">
              <SIdentify :identifyCode="identifyCode"></SIdentify>
            </div>
          </template>
        </el-input>
      </el-form-item>-->

      <div >

        <input type="radio"  value="2"  v-model="ruleForm.checkedValue" ><label style="margin-right: 20px">师生</label>
        <input type="radio" value="3" v-model="ruleForm.checkedValue" ><label >管理员</label>
       <!-- <input type="radio"  value="2" v-model="ruleForm.roleType"><label style="margin-right: 20px">师生</label>
        <input type="radio" value="3" v-model="ruleForm.roleType"><label >管理员</label>-->
      </div>

      <div class="rt" style="margin-right: 30px">
        <el-checkbox v-model="checked" style="color:#a0a0a0;">一周内自动登录</el-checkbox>
      </div>

      <el-form-item style="margin-right: 30px">
        <el-button type="primary" @click="submitForm('ruleForm')" style="width:100%; text-align: center">登录</el-button>

      </el-form-item>
    </el-form>
    <div class="tx" >
      学生可使用学号或身份证号，教职工可登陆校园网账号。
    </div>
  </div>
</template>
<script>
  import { Toast,MessageBox} from 'mint-ui';
  import SIdentify from './identify' //注意引入路径
  import CryptoJS from "crypto-js";
  import { login,adminLogon, OK} from '../api/data.js'
  export default {
    data() {
      return {
        ruleForm: {
          username: '',
          password:'',
          checkedValue:'2',
          verifyCode: "",
          roleType:this.$store.state.roleType,
        },
        rules: {
          username: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            { min: 2, max: 16, message: '长度在 2 到 16 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 5, max: 16, message: '长度在 5 到 16 个字符', trigger: 'blur' }
          ],
          verifyCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
        },
        verifyCodeImg:"",
        identifyCodes: '1234567890abcdefjhijkinpqrsduvwxyz',
        identifyCode: '',
        checked: false
      };
    },
    //页面加载调用获取cookie值
    mounted() {
      this.getCookie();
      // 初始化验证码
      this.identifyCode = ''
     // this.makeCode(this.identifyCodes, 4)

    },
    methods: {
      // 重置验证码
      refreshCode () {
        this.identifyCode = ''
        this.makeCode(this.identifyCodes, 4)
      },
      makeCode (o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
        }
      },
      randomNum (min, max) {
        return Math.floor(Math.random() * (max - min) + min)
      },
      submitForm(formName) {
        const self = this;
        //判断复选框是否被勾选 勾选则调用配置cookie方法
        if (self.checked == true) {
          //传入账号名，密码，和保存天数3个参数
          self.setCookie(self.ruleForm.username, self.ruleForm.password, 7);
        }else {
          console.log("清空Cookie");
          //清空Cookie
          self.clearCookie();
        }
        if(self.ruleForm.username.trim().length===0){
          Toast('账号不能为空')
          return;
        }
        if(self.ruleForm.password.trim().length===0){
          Toast('密码不能为空')
          return;
        }
/*        if(self.ruleForm.verifyCode.trim().length===0){
          Toast('验证码不能为空')
          return;
        }
        if (self.ruleForm.verifyCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
          this.$message.error('请填写正确验证码')
         //
          return
        }*/
        //获取登录角色 2 师生 ，3：管理员
        window.localStorage.clear();//清除所有之前的localStorage
        if(self.ruleForm.checkedValue === '2'){
          login(self.ruleForm.username,self.ruleForm.password).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true && res.data.data.identity){
                this.$store.dispatch('setRoleType',"2");//记录登录的角色
                //设置Vuex登录标志为true，默认userLogin为false
                /*   this.$store.dispatch("userLogin", true);*/
                //Vuex在用户刷新的时候userLogin会回到默认值false，所以我们需要用到HTML5储存
                //我们设置一个名为Flag，值为isLogin的字段，作用是如果Flag有值且为isLogin的时候，证明用户已经登录了。
                localStorage.setItem("Flag", "isLogin");
                localStorage.setItem("userId", res.data.data.uid);//id
                localStorage.setItem("identity", res.data.data.identity);//.登录账号
                localStorage.setItem("usertype", res.data.data.type);
                localStorage.setItem("username", res.data.data.username); //姓名
                localStorage.setItem("telePhone", res.data.data.telePhone); //手机号码
                localStorage.setItem("classNameOrDeparment", res.data.data.classUnitName); //班级或部门信息
                //console.log("this.$route.query.redirect："+this.$route.query.redirect)
                if (this.$route.query.redirect) {
                  this.$router.replace({
                    path: this.$route.query.redirect
                  })
                } else {
                  this.$router.push({
                    path: '/myTZ'
                  })
                }
              }else{
                Toast('账号或密码错误')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else if(self.ruleForm.checkedValue === '3') {
          adminLogon(self.ruleForm.username,self.ruleForm.password).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true  && res.data.data.operator){
                this.$store.dispatch('setRoleType',"3");//记录登录的角色
                //我们设置一个名为Flag，值为isLogin的字段，作用是如果Flag有值且为isLogin的时候，证明用户已经登录了。
                localStorage.setItem("Flag", "isLogin");
                localStorage.setItem("operator", res.data.data.operator);//登录账号
                localStorage.setItem("adminId", res.data.data.adminId);
                localStorage.setItem("usertype", res.data.data.type);
                localStorage.setItem("adminName", res.data.data.adminName); //姓名
                localStorage.setItem("telPhone", res.data.data.telePhone); //手机号码
                if (this.$route.query.redirect) {
                  this.$router.replace({
                    path: this.$route.query.redirect
                  })
                } else {
                  this.$router.push({
                    path: '/adminIndex'//跳转到管理员手机版主界面
                  })
                }

              }else{
                Toast('账号或密码错误')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }
      },
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
        let exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数

        var userName = CryptoJS.AES.encrypt(c_name+'', "gljp123").toString();
        var password = CryptoJS.AES.encrypt(c_pwd+'', "gljp123").toString();

        //字符串拼接cookie
        window.document.cookie = "userName" + "=" + userName + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie = "password" + "=" + password + ";path=/;expires=" + exdate.toGMTString();
      },
      //读取cookie
      getCookie: function() {
        if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split('='); //再次切割
            //判断查找相对应的值
            if (arr2[0] == 'userName') {
              //  console.log(arr2[1])
              // Decrypt，将解密后的内容赋值给账号
              var bytes = CryptoJS.AES.decrypt(arr2[1], "gljp123");
              this.ruleForm.username = bytes.toString(CryptoJS.enc.Utf8); //保存到保存数据的地方
            } else if (arr2[0] == 'password') {
              var bytes = CryptoJS.AES.decrypt(arr2[1], "gljp123");
              this.ruleForm.password = bytes.toString(CryptoJS.enc.Utf8);
            }
          }
          this.checked = true;
        }
      },
      //清除cookie
      clearCookie: function() {
        this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      }

    },
    components:{
      SIdentify
    }
  }
</script>

<style lang="scss" scoped>
  .login{
    width:90%;
    margin-top:60px;
    text-align:center;
    padding-left: 20px;
    padding-right: 20px;
  }
  .rt{
    float:right;
    margin-bottom:10px;
  }
  .tx{
    width:90%;
    padding-right:2%;
    padding-left: 2%;
    margin-top:20px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue